
import { initialState } from './initialState';
import { ROOT_SLICE, sanitizeToggleState } from './constants';
import {
  setReportCounts,
  setToggleState,
	setRefReportAggs,
  clear,
} from './actions';
import { selectThisSlice } from './selectors';

const INITIAL_STATE = initialState;
delete INITIAL_STATE.isInitialized;

// ************
// PARTS
// ************
const reducerParts = {
  [clear]: state => {
    const rootSlice = selectThisSlice(state);

    return {
      ...state,
      [ROOT_SLICE]: {
        ...rootSlice,
        ...INITIAL_STATE
      }
    };
  },

	[setReportCounts]: (
		state,
		{ payload: { countExistingReports, countGhostReports } }
	) => {
		const rootSlice = selectThisSlice(state);

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				countExistingReports: countExistingReports || 0, 
				countGhostReports: countGhostReports || 0,
			}
		};
  },

	[setToggleState]: (
		state,
		{ payload: { toggleState } }
	) => {
		const rootSlice = selectThisSlice(state);

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				toggleState: sanitizeToggleState(toggleState)
			}
		};
  },

	[setRefReportAggs]: (
		state,
		{ payload: { reportAggs } }
	) => {
		const rootSlice = selectThisSlice(state);

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				reportAggs
			}
		};
  },  
};


export default reducerParts;
